import { EarnTabRoutes } from '../earn.navigator';

export const useEarnPageNavigator = () => {
  const data = [
    {
      labelKey: 'earn-invest::glossary.discover',
      value: EarnTabRoutes.Discover
    },
    {
      labelKey: 'earn-invest::glossary.portfolio',
      value: EarnTabRoutes.Portfolio
    },
    {
      labelKey: 'earn-invest::glossary.history',
      value: EarnTabRoutes.History
    }
  ];

  return {
    data
  };
};
